import { matchPath } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig";

/**
 * appModules — Fuente única de las apps (Unity WebGL) de la plataforma.
 *
 * Cada entrada:
 *   path     — ruta completa de la app (misma que registra AppViews)
 *   importer — import dinámico del componente (literal, para que webpack
 *              genere el chunk). Import absoluto: baseUrl=src (jsconfig.json).
 *   kind     — marco con el que AppPopup lo monta: "unity" (por defecto,
 *              lienzo 16:9 oscuro con Pantalla Completa) o "tool" para
 *              pantallas de administración (modal claro, alto automático).
 *   title    — (opcional) título del popup. Si falta, AppPopup lo deriva del
 *              último segmento de la ruta.
 *
 * Consumido por:
 *   - views/app-views/index.js  → registra las <Route> de apps
 *   - components/shared-components/AppPopup → monta la app dentro de un modal
 *
 * El ORDEN de este array es irrelevante: los consumidores usan
 * `appModulesBySpecificity`, que resuelve siempre por la ruta más específica.
 * Agrega entradas nuevas donde sea legible (junto a sus hermanas).
 */
export const appModules = [
  { path: `${APP_PREFIX_PATH}/apps/learning/SQM/QuimicaFlujos`, importer: () => import("views/app-views/apps/learning/SQM/QuimicaFlujos") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SQM/PartesPiezas`, importer: () => import("views/app-views/apps/learning/SQM/PartesPiezas") },
  { path: `${APP_PREFIX_PATH}/apps/Generico/Vestimenta`, importer: () => import("views/app-views/apps/Generico/Vestimenta") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/Vestimenta`, importer: () => import("views/app-views/apps/learning/Logistics/Vestimenta") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/ConstruccionDemo`, importer: () => import("views/app-views/apps/learning/Logistics/ConstruccionDemo") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/Riesgos`, importer: () => import("views/app-views/apps/learning/Logistics/Riesgos") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/Onboarding`, importer: () => import("views/app-views/apps/learning/Logistics/Onboarding") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/FlujoTrabajo`, importer: () => import("views/app-views/apps/learning/Logistics/FlujoTrabajo") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PartesPiezas`, importer: () => import("views/app-views/apps/learning/Logistics/PartesPiezas") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PartesPiezasSinBrotli`, importer: () => import("views/app-views/apps/learning/Logistics/PartesPiezasSinBrotli") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PypLogistics`, importer: () => import("views/app-views/apps/learning/Logistics/PypDuoc") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PypDuoc`, importer: () => import("views/app-views/apps/learning/Logistics/PypDuoc") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/Pyp`, importer: () => import("views/app-views/apps/learning/Logistics/Pyp") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/FlujoTrabajo2024`, importer: () => import("views/app-views/apps/learning/Logistics/FlujoTrabajo2024") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PartesPiezas2024`, importer: () => import("views/app-views/apps/learning/Logistics/PartesPiezas2024") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/ConstruccionLogistica2024`, importer: () => import("views/app-views/apps/learning/Logistics/ConstruccionLogistica2024") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/ConstruccionLogistica2024SinBrotli`, importer: () => import("views/app-views/apps/learning/Logistics/ConstruccionLogistica2024SinBrotli") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/ConstruccionLogistica2025`, importer: () => import("views/app-views/apps/learning/Logistics/ConstruccionLogistica2025") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/ConstruccionLogistica`, importer: () => import("views/app-views/apps/learning/Logistics/ConstruccionLogistica") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/Prevencion/PartesPiezas`, importer: () => import("views/app-views/apps/learning/Logistics/Prevencion/PartesPiezas") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/Prevencion/FlujoTrabajo`, importer: () => import("views/app-views/apps/learning/Logistics/Prevencion/FlujoTrabajo") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/Prevencion/FlujoTrabajoSinBrotli`, importer: () => import("views/app-views/apps/learning/Logistics/Prevencion/FlujoTrabajoSinBrotli") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Electricidad/FTCircuitos`, importer: () => import("views/app-views/apps/learning/Electricidad/FTCircuitos") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PypAiep`, importer: () => import("views/app-views/apps/learning/Logistics/PypAiep") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PypAiep/Dosimetro`, importer: () => import("views/app-views/apps/learning/Logistics/PypAiep/Dosimetro") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Logistics/PypAiep/Sonometro`, importer: () => import("views/app-views/apps/learning/Logistics/PypAiep/Sonometro") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Edification/Vestimenta`, importer: () => import("views/app-views/apps/learning/Edification/Vestimenta") },
  { path: `${APP_PREFIX_PATH}/apps/learning/Gastronomia/FlujoTrabajo`, importer: () => import("views/app-views/apps/learning/Gastronomia/FlujoTrabajo") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SGS/FlujoTrabajo`, importer: () => import("views/app-views/apps/learning/SGS/FlujoTrabajo") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SGS/FlujoTrabajoV2`, importer: () => import("views/app-views/apps/learning/SGS/FlujoTrabajoV2") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SGS/VestimentaSGS`, importer: () => import("views/app-views/apps/learning/SGS/VestimentaSGS") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SNA/Riego/PartesPiezas`, importer: () => import("views/app-views/apps/learning/SNA/Riego/PartesPiezas") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SNA/Riego/Montaje`, importer: () => import("views/app-views/apps/learning/SNA/Riego/Montaje") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SNA/Riego/FlujoTrabajo`, importer: () => import("views/app-views/apps/learning/SNA/Riego/FlujoTrabajo") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SNA/Alimentacion/Bodega`, importer: () => import("views/app-views/apps/learning/SNA/Alimentacion/Bodega") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SNA/Alimentacion/Cocina`, importer: () => import("views/app-views/apps/learning/SNA/Alimentacion/Cocina") },
  { path: `${APP_PREFIX_PATH}/apps/learning/SNA/Alimentacion/Comedor`, importer: () => import("views/app-views/apps/learning/SNA/Alimentacion/Comedor") },
  { path: `${APP_PREFIX_PATH}/apps/produccion/Generadora/Construccion`, importer: () => import("views/app-views/apps/produccion/Generadora/Construccion") },
  { path: `${APP_PREFIX_PATH}/apps/produccion/Engie/Construccion`, importer: () => import("views/app-views/apps/produccion/Engie/Construccion") },
  { path: `${APP_PREFIX_PATH}/apps/produccion/Engie/MantenedorObjetos`, importer: () => import("views/app-views/apps/produccion/Engie/MantenedorObjetos"), kind: "tool", title: "Mantenedor de URLs por Objeto — Engie" },
  { path: `${APP_PREFIX_PATH}/apps/produccion/Engie/TourVirtual`, importer: () => import("views/app-views/apps/produccion/Engie/TourVirtual") },
  { path: `${APP_PREFIX_PATH}/apps/learning/test`, importer: () => import("views/app-views/apps/learning/Test") },
];

/**
 * ¿La ruta corresponde a una app que debe abrirse en popup?
 * Heurística: cualquier ruta bajo /apps/.
 */
export function isAppPath(pathname) {
  return typeof pathname === "string" && pathname.includes("/apps/");
}

/**
 * Misma lista, ordenada de la ruta más específica a la más genérica.
 *
 * Es la que deben consumir tanto las <Route> como el resolvedor: al probar
 * primero la ruta más larga, ".../PypAiep/Dosimetro" gana sobre ".../PypAiep",
 * sin depender de cómo esté ordenado `appModules`.
 */
export const appModulesBySpecificity = [...appModules].sort(
  (a, b) => b.path.length - a.path.length
);

/**
 * Devuelve la ENTRADA completa del módulo que corresponde a una ruta, o null.
 *
 * Usa el `matchPath` de React Router para que el criterio sea EXACTAMENTE el
 * de las <Route> (match por segmentos, no por substring): ".../FlujoTrabajo"
 * no captura ".../FlujoTrabajoSinBrotli". Admite sufijos extra en la ruta
 * (enlaces LTI con segmentos o query adicionales).
 *
 * Se devuelve la entrada (no solo el importer) porque AppPopup necesita `kind`
 * para decidir con qué marco de modal montar el módulo.
 */
export function getAppModule(pathname) {
  if (typeof pathname !== "string") return null;
  return (
    appModulesBySpecificity.find((m) => matchPath(pathname, { path: m.path })) ||
    null
  );
}

/** Igual que getAppModule, pero devuelve solo el importer (o null). */
export function getAppImporter(pathname) {
  const match = getAppModule(pathname);
  return match ? match.importer : null;
}

export default appModules;
